
import React, { ReactNode, useState } from 'react';
import './tabs.scss';
import TabLabel, { ITabLabelProps } from './components/tab-label/tab-label';

export enum TABS_SIZE_VARIANTS {
    DEFAULT = 'default',
    SMALL = 'small',
}

export enum TAB_LABEL_ALIGNMENTS {
    CENTER = 'align-center',
    LEFT = 'align-left',
}

interface ITabProps extends ITabLabelProps {
    content: ReactNode;
}

interface IProps {
    sizeVariant?: TABS_SIZE_VARIANTS;
    labelAlignment?: TAB_LABEL_ALIGNMENTS;
    tabs: ITabProps[];
}

export const Tabs: React.FC<IProps> = ({ tabs, sizeVariant = TABS_SIZE_VARIANTS.DEFAULT, labelAlignment = TAB_LABEL_ALIGNMENTS.LEFT }) => {

    const [activeTabIndex, setActiveTabIndex] = useState<number>(0);

    const onTabClick = (index: number, tabOnClickCallback?: () => void) => {
        setActiveTabIndex(index);
        tabOnClickCallback?.();
    }

    return (
        <div className='tabs-container'>
            <div className={`tabs-header ${labelAlignment}`} role='tablist'>
                {tabs.map((tab, index) => <TabLabel
                    key={index}
                    onClick={() => onTabClick(index, tab.onClick)}
                    isActive={activeTabIndex === index}
                    disabled={tab.disabled}
                    label={tab.label}
                    icon={tab.icon}
                    variant={sizeVariant}
                />
                )}
            </div>
            {tabs.map((tab, index) => (
                <>
                    {activeTabIndex !== index 
                        ? null
                        : (
                            <div key={index}
                                role="tabpanel"
                                aria-hidden={activeTabIndex !== index}
                                className={`tab-content`}
                            >
                                {tab.content}
                            </div>
                        )
                    }
                </>
            ))}
        </div>
    );
}
